export default __webpack_public_path__ + "static/media/yuryu-06.6469720b.svg";